import { Base } from "./colors.base";
import { Color } from "./components/color";

export const Colors = Object.assign(Base, {
    Color
});
